import commonTranslations from 'yeself-common/resources/localization/data.json';

import localeData from 'Console/localization';

/**
 * translationLoader
 * - taken from yeself-common
 * - used to get proper language for react-intl package
 *
 * @param {string} language
 *
 * @returns {{ language: string, messages: object }}
 */
const translationLoader = (language = 'en') => {
    let newLang = language;
    // Split locales with a region code
    const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

    // TODO: handle missing locales better
    const availableLocales = Object.keys(localeData).filter(
        (lang) => lang === language || lang === languageWithoutRegionCode
    );

    if (!localeData[language]) {
        newLang = languageWithoutRegionCode;
    }
    if (!availableLocales.length) {
        newLang = 'en';
    }

    // Try full locale, try locale without region code, fallback to 'en'
    const messages = {
        ...localeData[language],
        ...commonTranslations[language],
    };

    return {
        language: newLang,
        messages,
    };
};

export const mapLanguageCodeToCountryCode = (languageCode) => {
    switch (languageCode.toLowerCase()) {
        case 'en':
            return 'us';
        default:
            return languageCode;
    }
};

export const mapCountryCodeToLanguage = (countryCode = 'us') => {
    switch (countryCode.toLowerCase()) {
        case 'us':
            return 'en';
        default:
            return countryCode;
    }
};

export default translationLoader;
